import { useState, useCallback } from "react";
import { Snackbar, Alert, useTheme } from "@mui/material";
import { atom, useAtom } from "jotai";

const notificationAtom = atom({
  open: false,
  message: "",
  severity: "info",
  autoHideDuration: 3000,
});

export const useNotification = () => {
  const [notification, setNotification] = useAtom(notificationAtom);

  const showNotification = useCallback(
    (message, options = {}) => {
      setNotification({
        open: true,
        message,
        severity: options.severity || "info",
        autoHideDuration: options.autoHideDuration || 3000,
      });
    },
    [setNotification]
  );

  const hideNotification = useCallback(() => {
    setNotification((prev) => ({ ...prev, open: false }));
  }, [setNotification]);

  return {
    showNotification,
    hideNotification,
  };
};

export const NotificationComponent = () => {
  const [notification, setNotification] = useAtom(notificationAtom);
  const theme = useTheme();

  const handleClose = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={notification.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.severity}
        variant="outlined"
        sx={{
          minWidth: "280px",
          backgroundColor: theme.palette.background.paper,
        }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};
